import { render, staticRenderFns } from "./CalendarWeek.vue?vue&type=template&id=4b48f00a"
import script from "./CalendarWeek.vue?vue&type=script&lang=js"
export * from "./CalendarWeek.vue?vue&type=script&lang=js"
import style0 from "./CalendarWeek.vue?vue&type=style&index=0&id=4b48f00a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports